import { format } from 'date-fns';
import DynamicInputGrid from '../software-dynamic-version-6/popup-input-grid-v-6';
import React, { useRef, useState , useEffect,useMemo} from 'react';

const DyeingTransactionsAdd = (props) => {
let [gridDataSource,setDataSource] = useState([])
let [columns,setColumns] = useState([])
let [callGridDataSource,setCallGridDataSource] = useState(false)
let GridDataSource = [
    {entryno:1,value:'dfd'},
    {Command:undefined,entryno:'1sdf',value:'dfd-row2'},
    {Command:undefined,entryno:32222,value:'dfd-row3'},
]

const addbutton = async (colss)=>{
let columnss = [
    { field: "Command", headerText: "Actions", width: "150px", textAlign: "left", headerTextAlign: "center", other: [{
                template:(args)=>{
                    return(
                        <>
                        <button
                        onClick={handleValidate}
                        >
                            Validate
                        </button>
                        </>
                    )
                }
              }] },
              ...colss
]
return columnss
}
useEffect(async ()=>{

let cols=        [
              
              { field: "entryno", headerText: "entry No", width: "150px", textAlign: "left", headerTextAlign: "center", other: [{format:'n0',}] },
              { field: "value", headerText: "value", width: "150px", textAlign: "left", headerTextAlign: "center", other: [] },

        ]
    let updatedcolumns = await addbutton(cols)
        setColumns(updatedcolumns)
 
setCallGridDataSource(true)
setDataSource(GridDataSource)
setTimeout(() => {
    
    setCallGridDataSource(false)
}, 200);
},[])

const handleValidate =(args)=>{
    console.log(args)
    setCallGridDataSource(true)
    setDataSource([])
    setCallGridDataSource(false)

    setTimeout(() => {
        setCallGridDataSource(true)
setDataSource([
    {entryno:1+args.entryno,value:'dfd'},
    {Command:undefined,entryno:1,value:'dfd-row2'},
])
}, 2000);
setTimeout(() => {
    
    setCallGridDataSource(false)
}, 5000);
}
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
     <DynamicInputGrid
        Id='DyeingTransactionsDetail'
        
        ColumnsList={columns}
        GridDataSource= {[
          {
        DataSourceType:callGridDataSource == true ? 'Data' : 'REST',
        DataSource:  gridDataSource,
        // CreateColumns: [{columnName:'IsEdit',columnValue:false}]
         }]
  }
        DefaultSortedColumnName={''}
      
        ListActionComplete={(grid ,args)=>{

        }}
        
        ToolbarClicking ={(grid,args,selectedRows,getListService,saveData,dataSource)=>{
          console.log(grid.dataSource)
          console.log(args)
          console.log(selectedRows)
          console.log(getListService)
          console.log(saveData)
          console.log(dataSource)
        


        }}
        // ToolbarClicking={()=>{}}
        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
        AllowTemplate={false}
        ToolbarOption={['Delete']}
        AllowGrouping={false}
        AllowExcelExport={false}
        AllowPdfExport={false} 
        ShowColumnChooser={false}
        AllowPaging={true}
        AllowDataBound={false}
        ListSecurity={true}
        AddSecurity={false}
        EditSecurity={false}
        DeleteSecurity={true}
        DefaultSortedColumnSort={'Descending'}
        FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
        GroupColumns={[]} 
        ListDelete={[]}
        DeleteType={'hard'} 
        GridEditSettingMode={'Normal'}
        GridEditSettingHeaderTemplate={'<p></p>'}
        GridSumColumns={[]}
        AllowGridSum={true}
            {...props}
            ></DynamicInputGrid>
 </div>
  );
}; 

export default DyeingTransactionsAdd;
